export default "__VITE_ASSET__hOjIGG39__"